import { render, staticRenderFns } from "./CenterViewPreview3dPlate_Ap.vue?vue&type=template&id=3f26892f&scoped=true"
import script from "./CenterViewPreview3dPlate_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewPreview3dPlate_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewPreview3dPlate_Ap.vue?vue&type=style&index=0&id=3f26892f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f26892f",
  null
  
)

export default component.exports